module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"row\"> <div class=\"col-auto\"> <h5><span class=\"fa fa-bank\"></span> <strong>")
    ; __append(escapeFn( locals.last4 ))
    ; __append("</strong></h5> </div> <div class=\"col\"> <div>")
    ; __append(escapeFn( locals.bank_name ))
    ; __append("</div> <div class=\"small text-muted\">Account Name</div> </div> <div class=\"col-3\"> <div>")
    ; __append(escapeFn( locals.verified ? "Verified" : "Pending" ))
    ; __append("</div> <div class=\"small text-muted\">Status</div> </div> <div class=\"col-auto\"> <button type=\"button\" class=\"close remove_account\">&times;</button> </div> </div> ")
    ;  if(!locals.verified) { 
    ; __append(" <div class=\"text-md-right my-4\"><button class=\"verify_account btn btn-secondary\">Verify Account</button></div> ")
    ;  } 
    ; __append(" <div class=\"recharge_settings\"></div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/pages/billing/payment_methods/bank_account_details/template.ejs
// module id = 1251
// module chunks = 1